"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _panel = _interopRequireDefault(require("@insided/deprecated-control/panel"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var maxBadgesDisplayed = 5;

var BadgesOverviewPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BadgesOverviewPanel, _Component);

  var _super = _createSuper(BadgesOverviewPanel);

  function BadgesOverviewPanel() {
    var _this;

    (0, _classCallCheck2.default)(this, BadgesOverviewPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      viewAll: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showAllBadges", function () {
      _this.setState({
        viewAll: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(BadgesOverviewPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return (0, _preact.h)(_panel.default, {
        collapsible: true,
        title: "Badges",
        customClass: "userbox badge-overview-panel",
        titleClass: "badge-overview__panel-header",
        bodyClass: "badge-overview__panel-body"
      }, !props.loading && props.badgeList.length === 0 && (0, _preact.h)("div", null, "This user hasn't earned any badges yet"), props.badgeList.length > 0 && props.badgeList.filter(function (badge, index) {
        return index < maxBadgesDisplayed || state.viewAll;
      }).map(function (badge) {
        return (0, _preact.h)("div", {
          key: badge.id,
          className: (0, _classnames.default)('badge-block', 'qa-badge-block-' + badge.id)
        }, (0, _preact.h)("img", {
          src: (0, _absoluteUrlRuntime.resolveUrl)(badge.image),
          alt: badge.title
        }), " ", (0, _preact.h)("div", {
          className: "badge-title"
        }, badge.title));
      }), props.badgeList.length > maxBadgesDisplayed && !state.viewAll && (0, _preact.h)("a", {
        href: "#",
        onClick: function onClick() {
          return _this2.showAllBadges();
        }
      }, "View all ", props.badgeList.length, " badges"));
    }
  }]);
  return BadgesOverviewPanel;
}(_preact.Component);

var _default = BadgesOverviewPanel;
exports.default = _default;